/* ======================  SCRIPTS ====================== */
/************  JQUERY EST DISPONIBLE ICI *****************/

    (function($){

        $('document').ready(setup);

        function setup() {
            //initTarteAuCitron();
            $(window).scroll(showHideStickyMenu);
            $('.navigation-widgets .elementor-search-form__submit').click(showHideSearchBar);
            $('.wpcf7-form .elementor-button').click(testForm);
            placeMegaMenuArrow();
            detectIfMegaMenuLinkIsActive();
            siteGroupPanel();
            checkInstantFormFields();
            $('.plsfe-item__active').parent().addClass('active');
            if($('.ecs-posts.elementor-grid').length !== 0) {
                $('.ecs-posts.elementor-grid.elementor-posts--skin-archive_custom').masonry({
                    itemSelector: '.ecs-post-loop',
                    horizontalOrder: true,
                    gutter: 30,
                });
            }
        }

        function initTarteAuCitron() {
            tarteaucitron.init({
                "privacyUrl": "",
                "hashtag": "#onet",
                "cookieName": "onet",
                "orientation": "middle",
                "groupServices": false,
                "showAlertSmall": true,
                "cookieslist": true,
                "closePopup": false,
                "showIcon": false,
                "iconPosition": "BottomRight",
                "adblocker": false,
                "DenyAllCta" : true,
                "AcceptAllCta" : true,
                "highPrivacy": true,
                "handleBrowserDNTRequest": false,
                "removeCredit": true,
                "moreInfoLink": true,
                "useExternalCss": true,
                "useExternalJs": false,
                "readmoreLink": "",
                "mandatory": true
            });

            if(window.location.href.indexOf('groupeonet.com') !== -1) {
                tarteaucitron.user.googletagmanagerId = 'GTM-778Q';
                tarteaucitron.user.gajsMore = function () { ga('set', 'anonymizeIp', true); };
            }

            (tarteaucitron.job = tarteaucitron.job || []).push('googletagmanager');
        }

        // Navigation Sticky
        function showHideStickyMenu() {
            if($(this).scrollTop() >= 300) {
                if($('.elementor-location-header.sticky').length === 0) {
                    $('.elementor-location-header').clone().appendTo("body").addClass('sticky hide');
                    // On rajoute les fonctions pour gérer le menu responsive
                    $('.elementor-location-header.sticky .cmm4e-toggle').click(function() {
                        if($('.elementor-location-header.sticky .cmm4e-container').hasClass('cmm4e-active')) {
                            $('.elementor-location-header.sticky .cmm4e-container').removeClass('cmm4e-active');
                            $('.elementor-location-header.sticky .cmm4e-toggle').removeClass('toggled');
                        }else {
                            $('.elementor-location-header.sticky .cmm4e-container').addClass('cmm4e-active');
                            $('.elementor-location-header.sticky .cmm4e-toggle').addClass('toggled');
                        }
                    });

                    $('.elementor-location-header.sticky .elementor-search-form__submit').removeClass('active');
                    $('.elementor-location-header.sticky  .elementor-search-form__input').removeClass('show');
                    $('.elementor-location-header.sticky .elementor-search-form__submit').click(showHideSearchBar);
                    placeMegaMenuArrow();

                    $('.elementor-location-header.sticky .cmm4e-item-toggle').each(function() {
                        $(this).click(function() {
                            if($(this).parent().hasClass('cmm4e-item-expanded')) {
                                $(this).css('transform', 'rotate(0deg)');
                                $(this).parent().removeClass('cmm4e-item-expanded');
                                $(this).parent().children('.cmm4e-sub-panel').slideUp();
                            }else {
                                $(this).css('transform', 'rotate(225deg)');
                                $(this).parent().addClass('cmm4e-item-expanded');
                                $(this).parent().children('.cmm4e-sub-panel').slideDown();
                            }
                        });
                    });
                }else {
                    $('.elementor-location-header.sticky').removeClass('hide');
                }
            }else {
                $('.elementor-location-header.sticky').addClass('hide');
                $('.elementor-location-header.sticky .elementor-search-form__submit').removeClass('active');
                $('.elementor-location-header.sticky  .elementor-search-form__input').removeClass('show');
                $('.elementor-location-header.sticky  .elementor-search-form').removeClass('expanded');
            }
        }

        // Afficher/Cacher le formulaire de recherche
        function showHideSearchBar(e) {
            if($(this).hasClass('active')) {
                if($(this).parent().children('.elementor-search-form__input').val() === '' || $(this).parent().children('.elementor-search-form__input').val() === ' ') e.preventDefault();
                $(this).removeClass('active');
                $(this).parent().children('.elementor-search-form__input').removeClass('show');
                var searchForm = $(this).parent().parent();
                setTimeout(function() { searchForm.removeClass('expanded'); }, 400);
            }else {
                e.preventDefault();
                $(this).parent().parent().addClass('expanded');
                $(this).addClass('active');
                $(this).parent().children('.elementor-search-form__input').addClass('show');
            }
        }

        // Fonction qui permet d'ajouter la flèche en haut des mégas menus
        function placeMegaMenuArrow() {
            $('.cmm4e-item-depth-0').each(function() {
                $(this).mouseenter(function() {
                    if($(window).width() >= 1200) {
                        $(this).children('.cmm4e-nav-link').addClass('open');
                        $(this).mouseleave(function() {
                            $(this).children('.cmm4e-nav-link').removeClass('open');
                        });
                    }
                });
            });
        }

        // Fonction
        function detectIfMegaMenuLinkIsActive() {
            var currentUrl = window.location.href;
            $('.cmm4e-content-wrapper .elementor-text-editor ul li').each(function() {
                var currentLink = $(this).children('a').attr('href');
                if(currentUrl.indexOf(currentLink) !== -1) $(this).addClass('current-item');
            });

            $('.cmm4e .cmm4e-menu-item').each(function() {
                var currentLink = $(this).children('.cmm4e-nav-link').attr('href');
                if(currentUrl.indexOf(currentLink) !== -1) $(this).addClass('cmm4e-current-menu-item');
            });
        }

        // Afficher/Cacher le panneau Sites du Groupe
        function siteGroupPanel() {
            if ( $(".navigation-btn").length ) {
                $(document).on('click', "button.navigation-btn", function(e) {
                    e.preventDefault();
                    $(".sitegroup").addClass("active");
                });

                $(document).on('click', ".sitegroup .btn-close", function(e) {
                    e.preventDefault();
                    $(".sitegroup").removeClass("active");
                });
            }
        }

        // Tester les formulaires en JS
        function testForm(e) {
            var fromId = $(this).parent().parent().parent().parent().attr('id');

            // vérification des saisies utilisateurs
            nbChampVide = 0;
            $('.error-msg').fadeOut(200);
            $('select.error').removeClass('error');
            $('select.valid').removeClass('valid');
            $('input.error').removeClass('error');
            $('input.valid').removeClass('valid');

            // On vérifie que l'utilisateur a coché les cases RGPD
            if($('#' + fromId+ ' input[name="rgpd[]"]').prop( "checked" ) == false) {
                $('#' + fromId+ ' input[name="rgpd[]"]').parent().parent().parent().parent().children('.error-msg').fadeIn(300);
                nbChampVide++;
            }

            // On vérifie s'il y a des select list obligatoire
            $('#' + fromId+ ' select.wpcf7-validates-as-required').each(function () {
                if(!$(this).parent().parent().hasClass('wpcf7cf-hidden')) {
                    if($(this).val() == '' || $(this).val() == ' ') {
                        $(this).addClass('error');
                        $(this).parent().children('.error-msg').fadeIn(300);
                        nbChampVide++;
                    }else {
                        $(this).addClass('valid');
                    }
                }
            });

            // On vérifie la saisie des champs obligatoire
            $('#' + fromId+ ' .form input.wpcf7-validates-as-required, #' + fromId+ ' .wpcf7-form input.wpcf7-validates-as-required').each(function() {
                if($(this).val() == "" || $(this).val() == " ") { // On vérifie que le champ n'est pas vide
                    nbChampVide++;
                    $(this).addClass('error');
                    $(this).parent().children('.error-msg').fadeIn(300);
                }else { // S'il n'est pas vide on vérifie s'il y a une verification supplémentaire sur le champ
                    var name = $(this).attr('name');
                    if(name === 'email') {
                        var regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
                        if (regex.test($(this).val()) === false) {
                            nbChampVide++;
                            $(this).addClass('error');
                            $(this).parent().children('.error-msg').fadeIn(300);
                        }else {
                            $(this).addClass('valid');
                        }
                    }else if(name === 'telephone') {
                        var regexPhone = /^((\+|00)33\s?|0)[1-9](\s?\d{2}){4}$/;
                        if (regexPhone.test($(this).val()) === false) {
                            nbChampVide++;
                            $(this).addClass('error');
                            $(this).removeClass('valid');
                            $(this).parent().children('.error-msg').fadeIn(300);
                        }else {
                            $(this).addClass('valid');
                        }
                    }else if(name === 'code_postal') {
                        var regexCodePostal = /[0-9]{5,5}/igm;
                        if (regexCodePostal.test($(this).val()) === false) {
                            nbChampVide++;
                            $(this).addClass('error');
                            $(this).removeClass('valid');
                            $(this).parent().children('.error-msg').fadeIn(300);
                        }else {
                            $(this).addClass('valid');
                        }
                    }else if(name === 'siret') {
                        var regexSiret = /[0-9]{14,14}/igm;
                        if (regexSiret.test($(this).val()) === false) {
                            nbChampVide++;
                            $(this).addClass('error');
                            $(this).removeClass('valid');
                            $(this).parent().children('.error-msg').fadeIn(300);
                        }else {
                            $(this).addClass('valid');
                        }
                    }else {
                        $(this).addClass('valid');
                    }
                }
            });

            // On vérifie que les textarea requis sont renseignés
            $('#' + fromId+ ' .form textarea.wpcf7-validates-as-required, #' + fromId+ ' .wpcf7-form textarea.wpcf7-validates-as-required').each(function() {
                if($(this).val() == "" || $(this).val() == " ") { // On vérifie que le champ n'est pas vide
                    nbChampVide++;
                    $(this).addClass('error');
                    $(this).parent().children('.error-msg').fadeIn(300);
                }else { // S'il n'est pas vide on vérifie s'il y a une verification supplémentaire sur le champ
                    $(this).addClass('valid');
                }
            });

            // On vérifie les champs requis dans les double champ
            $('#' + fromId+ ' .doubleverif input.wpcf7-validates-as-required, #' + fromId+ ' .wpcf7-form .doubleverif input.wpcf7-validates-as-required').each(function() {
                if($(this).val() == "" || $(this).val() == " ") { // On vérifie que le champ n'est pas vide
                    nbChampVide++;
                    $(this).addClass('error');
                }else {
                    var name = $(this).attr('name');
                    if(name == 'code_postal') {
                        var regexCodePostal = /[0-9]{5,5}/igm;
                        if (regexCodePostal.test($(this).val()) === false) {
                            nbChampVide++;
                            $(this).addClass('error');
                            $(this).removeClass('valid');
                        }else {
                            $(this).addClass('valid');
                        }
                    }else {
                        $(this).addClass('valid');
                    }
                }

                var parent = $(this).parent().parent();
                if(parent.find('.error').length !== 0) parent.find('.error-msg').fadeIn(300);
            });

            if(nbChampVide !== 0) {
                e.preventDefault();
                $("html, body").animate({ scrollTop: $('.error').offset().top - 150 }, 500);
            }else {
                $('#' + fromId).addClass('loading');
            }
        }

        // Vérification à la volée des champs du formulaire de contact
        function checkInstantFormFields() {
            $('.form input.wpcf7-validates-as-required, .wpcf7-form input.wpcf7-validates-as-required').focusout(function() {
                if($(this).val() == "" || $(this).val() == " ") { // On vérifie que le champ n'est pas vide
                    nbChampVide++;
                    $(this).addClass('error');
                    $(this).removeClass('valid');
                    $(this).parent().children('.error-msg').fadeIn(300);
                }else { // S'il n'est pas vide on vérifie s'il y a une verification supplémentaire sur le champ
                    var name = $(this).attr('name');
                    if(name == 'email') {
                        var regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
                        if (regex.test($(this).val()) == false) {
                            nbChampVide++;
                            $(this).addClass('error');
                            $(this).removeClass('valid');
                            $(this).parent().children('.error-msg').fadeIn(300);
                        }else {
                            $(this).addClass('valid');
                            $(this).removeClass('error');
                            $(this).parent().children('.error-msg').fadeOut(300);
                        }
                    }else if(name == 'telephone') {
                        var regexPhone = /^((\+|00)33\s?|0)[1-9](\s?\d{2}){4}$/;
                        if (regexPhone.test($(this).val()) == false) {
                            nbChampVide++;
                            $(this).addClass('error');
                            $(this).removeClass('valid');
                            $(this).parent().children('.error-msg').fadeIn(300);
                        }else {
                            $(this).addClass('valid');
                            $(this).removeClass('error');
                            $(this).parent().children('.error-msg').fadeOut(300);
                        }
                    }else if(name == 'code_postal') {
                        var regexCodePostal = /[0-9]{5,5}/igm;
                        if (regexCodePostal.test($(this).val()) == false) {
                            nbChampVide++;
                            $(this).addClass('error');
                            $(this).removeClass('valid');
                            $(this).parent().children('.error-msg').fadeIn(300);
                        }else {
                            $(this).addClass('valid');
                            $(this).removeClass('error');
                            $(this).parent().children('.error-msg').fadeOut(300);
                        }
                    }else if(name == 'siret') {
                        var regexSiret = /[0-9]{14,14}/igm;
                        if (regexSiret.test($(this).val()) == false) {
                            nbChampVide++;
                            $(this).addClass('error');
                            $(this).removeClass('valid');
                            $(this).parent().children('.error-msg').fadeIn(300);
                        }else {
                            $(this).addClass('valid');
                            $(this).removeClass('error');
                            $(this).parent().children('.error-msg').fadeOut(300);
                        }
                    }else {
                        $(this).addClass('valid');
                        $(this).removeClass('error');
                        $(this).parent().children('.error-msg').fadeOut(300);
                    }
                }
            });
            $('.form textarea.wpcf7-validates-as-required, .wpcf7-form textarea.wpcf7-validates-as-required').focusout(function() {
                if($(this).val() == "" || $(this).val() == " ") { // On vérifie que le champ n'est pas vide
                    nbChampVide++;
                    $(this).addClass('error');
                    $(this).removeClass('valid');
                    if($(this).parent().children('.error-msg').length === 0) {
                        $(this).parent().parent().children('.error-msg').fadeIn(300);
                    }else {
                        $(this).parent().children('.error-msg').fadeIn(300);
                    }
                }else { // S'il n'est pas vide on vérifie s'il y a une verification supplémentaire sur le champ
                    $(this).addClass('valid');
                    $(this).removeClass('error');
                    if($(this).parent().children('.error-msg').length === 0) {
                        $(this).parent().parent().children('.error-msg').fadeOut(300);
                    }else {
                        $(this).parent().children('.error-msg').fadeOut(300);
                    }
                }
            });
            $('.form select.wpcf7-validates-as-required, .wpcf7-form select.wpcf7-validates-as-required').on('change', function() {
                if($(this).val() == '' || $(this).val() == ' ') {
                    $(this).addClass('error');
                    $(this).removeClass('valid');
                    $(this).parent().children('.error-msg').fadeIn(300);
                    nbChampVide++;
                }else {
                    $(this).addClass('valid');
                    $(this).removeClass('error');
                    $(this).parent().children('.error-msg').fadeOut(300);
                }
            });

            // Limite nombre de caractères pour code postal
            $('input[name="code_postal"]').keypress(function () {
                var maxLength = $(this).val().length;
                if (maxLength >= 5) {
                    return false;
                }
            });

            // Limite nombre de caractères pour n°SIRET
            $('input[name="siret"]').keypress(function () {
                var maxLength = $(this).val().length;
                if (maxLength >= 14) {
                    return false;
                }
            });
        }

    })(jQuery);
